/**
 * Application constants
 *
 * Centralized configuration for the HandiPrêt marketplace.
 */

/** App metadata */
export const APP = {
    name: "HandiPrêt",
    description:
        "Prêt gratuit de matériel médical et paramédical pour les enfants en situation de handicap. Initiative solidaire 100% gratuite.",
    tagline: "Matériel solidaire pour enfants",
    url: process.env.NEXT_PUBLIC_APP_URL ?? "http://localhost:3000",
    email: "handipret@asso-lea.org",
    association: "Association LEA — Lutter, Écouter, Accompagner",
    phone: "07 62 05 81 30",
} as const;

/** Listing type labels and config */
export const LISTING_TYPES = {
    DONATION: {
        label: "Don",
        description: "Donnez votre matériel pour aider un enfant",
        icon: "Heart",
        color: "text-hp-orange",
        bgColor: "bg-hp-orange/10",
    },
    LOAN: {
        label: "Prêt gratuit",
        description: "Prêtez gratuitement votre matériel à une famille",
        icon: "HandHeart",
        color: "text-hp-purple",
        bgColor: "bg-hp-purple/10",
    },
    SALE: {
        label: "Vente solidaire",
        description: "Vendez votre matériel à prix solidaire",
        icon: "Tag",
        color: "text-hp-teal",
        bgColor: "bg-hp-teal/10",
    },
} as const;

/** Item condition labels */
export const ITEM_CONDITIONS = {
    NEW: { label: "Neuf", description: "Jamais utilisé, dans son emballage" },
    LIKE_NEW: { label: "Comme neuf", description: "Utilisé très peu, excellent état" },
    GOOD: { label: "Bon état", description: "Utilisé, fonctionne parfaitement" },
    FAIR: { label: "État correct", description: "Usure visible, fonctionne bien" },
    WORN: { label: "Usé", description: "Usure importante mais fonctionnel" },
} as const;

/** Default medical equipment categories */
export const DEFAULT_CATEGORIES = [
    { name: "Fauteuils roulants", slug: "fauteuils-roulants", icon: "Wheelchair" },
    { name: "Poussettes médicalisées", slug: "poussettes-medicalisees", icon: "Baby" },
    { name: "Matériel de bain", slug: "materiel-bain", icon: "Bath" },
    { name: "Sièges auto adaptés", slug: "sieges-auto", icon: "Car" },
    { name: "Béquilles & cannes", slug: "bequilles-cannes", icon: "Cane" },
    { name: "Loisirs adaptés", slug: "loisirs", icon: "Gamepad2" },
    { name: "Verticalisateurs", slug: "verticalisateurs", icon: "ArrowUp" },
    { name: "Harnais & aides à la marche", slug: "harnais-marche", icon: "Footprints" },
    { name: "Accessoires", slug: "accessoires", icon: "Package" },
    { name: "Autre matériel", slug: "autre", icon: "MoreHorizontal" },
] as const;

/** Navigation links */
export const NAV_LINKS = [
    { href: "/", label: "Accueil" },
    { href: "/annonces", label: "Trouver du matériel" },
    { href: "/annonces/nouvelle", label: "Donner du matériel" },
    { href: "/comment-ca-marche", label: "Comment ça marche" },
] as const;

/** Pagination defaults */
export const PAGINATION = {
    defaultPage: 1,
    defaultPerPage: 20,
    maxPerPage: 100,
} as const;
